import React from "react";
import Carousel from "../../UI/Carousel";
import { REACT_APP_URL } from "../../config";
// import ImageMagnifier from "./ImageMagnifier";

const ProductMagnification = ({ images, activeIndex, dot, path = "" }) => {
  return (
    <Carousel>
      {images.map((image, index) => {
        const isVideo = typeof image === "string" && image.includes("youtube.com");

        return (
          <div
            key={index}
            className={
              index === activeIndex ? `carousel-item active` : `carousel-item`
            }
          >
            {/* <ImageMagnifier
              src={`${REACT_APP_URL}/images/product/${image}`}
              height="85vh"
              width="auto"
            /> */}

            {isVideo ? (
              <iframe
                src={`${image.replace("watch?v=", "embed/")}&autoplay=1&mute=1`}
                title="Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  width: "100%",
                  height: "85vh",
                  border: "none",
                }}
              ></iframe>
            ) : path === "" ? (
              <div
                className="col-lg-12"
                style={{
                  backgroundImage: dot
                    ? `url(${REACT_APP_URL}/images/dotimage/${image})`
                    : `url(${REACT_APP_URL}/images/product/${image})`,
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  height: "85vh",
                }}
              />
            ) : (
              <div
                className="col-lg-12"
                style={{
                  backgroundImage: `url(${REACT_APP_URL}/images/${path}/${image})`,
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  height: "85vh",
                }}
              />
            )}
          </div>
        );
      })}
    </Carousel>
  );
};

export default ProductMagnification;
